import Form from "@utilities/form";
import Events from "@utilities/events";
import resetPasswordConstraints from "./reset-password-constraints";

const JS_HOOK_PASSWORD_RESET_FORM = `[js-hook-reset-password-form]`;
const JS_HOOK_PASSWORD_RESET_BUTTON = `[js-hook-reset-password-confirm]`;
const JS_HOOK_PASSWORD_RESET_BODY = `[js-hook-reset-password-body]`;
const JS_HOOK_PASSWORD_RESET_HEADER = `[js-hook-reset-password-header]`;
const MODAL_HOOK = `[js-hook-modal]`;
const MODAL_ID = "password-reset-modal";

class ResetPasswordForm extends Form {
  constructor(element) {
    super(element);

    this.formBody = document.querySelector(JS_HOOK_PASSWORD_RESET_BODY);
    this.formHeader = document.querySelector(JS_HOOK_PASSWORD_RESET_HEADER);
    this.initialHtml = this.formBody.innerHTML;
    this.modal = this.formBody.closest(MODAL_HOOK);

    // Init constraints
    this.initConstraints();

    // Events: Submit & Change Events
    this.bindChangeEvents();
    this.bindSubmitEvents();
  }

  /**
   * Show success message after form submit success
   * @param {String} html - data returned from API call
   */
  afterSubmitFormSuccess(data) {
    const { receivedMsgBody } = data;
    const { header } = data;
    if (receivedMsgBody) {
      this.formBody.innerHTML = receivedMsgBody;
      if (this.formHeader && header) {
        this.formHeader.innerHTML = header;
      }
      this.formBody.setAttribute("tabindex", -1);
      this.formBody.focus();
      Events.$on(`modal[${MODAL_ID}]::close`, () => {
        setTimeout(() => {
          this.resetRequestForm();
        }, 400);
      });
    }
    Events.$trigger('gtm::push', {
      data: {
        event: 'click_password_recovery'
      }
    });
  }

  resetRequestForm() {
    this.formBody.removeAttribute("tabindex");
    this.formBody.innerHTML = this.initialHtml;
    this.form = document.querySelector(JS_HOOK_PASSWORD_RESET_FORM);
    this.formHeader = document.querySelector(JS_HOOK_PASSWORD_RESET_HEADER);
    this.defaultSubmit = document.querySelector(JS_HOOK_PASSWORD_RESET_BUTTON);
    this.rebindEvents();
  }

  rebindEvents() {
    this.initButtonLoaders();
    this.initConstraints();
    this.bindChangeEvents();
    this.bindSubmitEvents();
  }

  /**
   * Init constraints for form validation
   */
  initConstraints() {
    this.constraints = resetPasswordConstraints(this.customValidationMessages);
  }
}

export default ResetPasswordForm;
